import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#A2FDC9',
      light: '#ECFEED',
      dark: '#1F7969',
    },
  },
});

export default theme; 